import orm from 'models';
import { ORMModelClasses, ORMModels, ORMSession } from 'models/externalTypes';
import { IdType, ModelType, createSelector } from 'redux-orm';
import { RootState } from 'store/store';

import { CreateSelector } from './createSelector';

const cs: unknown = createSelector;

/**
 * This overload is required because these selectors were originally
 * written in JS, passing a second parameter in the selector functions
 * passed to createSelector.  redux-orm typings don't allow tihs
 * But the code works.  TODO refactor to match typings
 */
export const createSelectorOverLoad = cs as CreateSelector;

export const dbStateSelector = (state: RootState) => state.orm;

export const modelSelector = <N extends ORMModels>(modelName: N) =>
  createSelector(orm, dbStateSelector, (session: ORMSession) => {
    const model = session[modelName];
    return model;
  });

export const allToModelArraySelector = (modelName: ORMModels) =>
  createSelector(orm, dbStateSelector, (session) => {
    const model = session[modelName];
    return model.all().toModelArray();
  });

export const allSelector = <R>(modelName: ORMModels) =>
  createSelector(orm, dbStateSelector, (session) => {
    const model = session[modelName];
    return model
      .all()
      .toModelArray()
      .map((entity) => entity.toViewModel() as unknown as R);
  });

/*
  (state, valueToMatchField) => Array
*/

/*
 TODO - see selector in:

 src/utils/dashboard/factories/utils/hooks/useStableCompaniesSelector.ts

 No coercion required.

 Problem caused by did
*/

export const allByFieldSelector = <M extends ORMModelClasses, R>(
  modelName: ORMModels,
  field: string,
) => {
  const searchSelector = (state: RootState, search: any) => {
    return search;
  };
  return createSelectorOverLoad(
    orm,
    dbStateSelector,
    searchSelector,
    (session: ORMSession, search: any) => {
      if (!search) {
        return [];
      }
      // ORMSchema[typeof modelName]
      const model = session[modelName] as unknown as ModelType<M>;
      const filteredModel = model.filter((entity) => {
        // @ts-ignore TODO
        const value = field.split('.').reduce((a, b) => {
          const attr = b as keyof typeof a;
          const newEntity = a[attr];
          return newEntity;
        }, entity);
        return Array.isArray(search)
          ? search.indexOf(value) > -1
          : value === search;
      });
      const modelArray = filteredModel.toModelArray();
      const mappedArray = modelArray.map(
        (entity) => entity.toViewModel() as unknown as R,
      );
      return mappedArray;
    },
  );
};

/**
 * Get one model instance.  Generic Param R is the return type of toViewModel method
 * defined on the model M,
 * @param modelName
 * @returns
 */
export const oneSelector = <M extends ORMModelClasses, R>(
  modelName: ORMModels,
) =>
  createSelectorOverLoad(
    orm,
    dbStateSelector,
    (state: RootState, id: IdType<M>) => id,
    (session: ORMSession, id: IdType<M>) => {
      const model = session[modelName] as unknown as ModelType<M>;
      const entity = model.withId(id);
      if (!entity) {
        return null;
      }

      const refEntity = entity.toViewModel();

      return refEntity as unknown as R;
    },
  );
